import type * as Types from '@trello/graphql/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import * as Apollo from '@apollo/client';
export const TrelloProposePlannerEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrelloProposePlannerEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezoneOffsetHours"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trello"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proposePlannerEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cardIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timezoneOffsetHours"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezoneOffsetHours"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"optIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"StringValue","value":"TrelloProposePlannerEvents","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"proposedEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<TrelloProposePlannerEventsMutation, TrelloProposePlannerEventsMutationVariables>;
const defaultOptions = {"context":{"operationName":"TrelloProposePlannerEvents","document":TrelloProposePlannerEventsDocument}} as const;
export type TrelloProposePlannerEventsMutationVariables = Types.Exact<{
  cardIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  timezoneOffsetHours: Types.Scalars['Float']['input'];
}>;


export type TrelloProposePlannerEventsMutation = { trello: (
    { __typename: 'TrelloMutationApi' }
    & { proposePlannerEvents?: Types.Maybe<(
      { __typename: 'TrelloProposePlannerEventsPayload' }
      & Pick<Types.TrelloProposePlannerEventsPayload, 'success'>
      & {
        errors?: Types.Maybe<Array<(
          { __typename: 'MutationError' }
          & Pick<Types.MutationError, 'message'>
        )>>,
        planner?: Types.Maybe<(
          { __typename: 'TrelloPlanner' }
          & Pick<Types.TrelloPlanner, 'id'>
          & { proposedEvents?: Types.Maybe<(
            { __typename: 'TrelloPlannerProposedEventConnection' }
            & { edges?: Types.Maybe<Array<(
              { __typename: 'TrelloPlannerProposedEventEdge' }
              & { node?: Types.Maybe<(
                { __typename: 'TrelloProposedEvent' }
                & Pick<Types.TrelloProposedEvent, 'endTime' | 'objectId' | 'startTime'>
                & { cards?: Types.Maybe<(
                  { __typename: 'TrelloProposedEventCardConnection' }
                  & { edges?: Types.Maybe<Array<(
                    { __typename: 'TrelloProposedEventCardEdge' }
                    & { node?: Types.Maybe<
                      | (
                        { __typename: 'TrelloCard' }
                        & Pick<Types.TrelloCard, 'id' | 'name'>
                      )
                      | (
                        { __typename: 'TrelloInboxCard' }
                        & Pick<Types.TrelloInboxCard, 'id' | 'name'>
                      )
                    > }
                  )>> }
                )> }
              )> }
            )>> }
          )> }
        )>,
      }
    )> }
  ) };

export type TrelloProposePlannerEventsMutationFn = Apollo.MutationFunction<
  TrelloProposePlannerEventsMutation,
  TrelloProposePlannerEventsMutationVariables
>;

/**
 * __useTrelloProposePlannerEventsMutation__
 *
 * To run a mutation, you first call `useTrelloProposePlannerEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrelloProposePlannerEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trelloProposePlannerEventsMutation, { data, loading, error }] = useTrelloProposePlannerEventsMutation({
 *   variables: {
 *      cardIds: // value for 'cardIds'
 *      timezoneOffsetHours: // value for 'timezoneOffsetHours'
 *   },
 * });
 */
export function useTrelloProposePlannerEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrelloProposePlannerEventsMutation,
    TrelloProposePlannerEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrelloProposePlannerEventsMutation,
    TrelloProposePlannerEventsMutationVariables
  >(TrelloProposePlannerEventsDocument, options);
}
export type TrelloProposePlannerEventsMutationHookResult = ReturnType<
  typeof useTrelloProposePlannerEventsMutation
>;
export type TrelloProposePlannerEventsMutationResult =
  Apollo.MutationResult<TrelloProposePlannerEventsMutation>;
export type TrelloProposePlannerEventsMutationOptions =
  Apollo.BaseMutationOptions<
    TrelloProposePlannerEventsMutation,
    TrelloProposePlannerEventsMutationVariables
  >;
